module.exports = __webpack_public_path__ + "h5/img/cygn2.1f9254cd.png";